export const formatRoyaltyCopy = (diminishedDate: string | number): string => {
  if (diminishedDate === 1) {
    return 'year';
  }
  if (diminishedDate === '1') {
    return 'year';
  }
  return 'years';
};
